import { apiInstance } from 'api/utils';

const palette = {
  getAllPalettes: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/palette/palettes/'
    });
  },
  getPalette: (name: string) => {
    return apiInstance.request({
      method: 'GET',
      url: `/palette/palettes/${name}/`
    });
  },
  savePalette: (name: string, colors: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/palette/palettes/`,
      data: { colors, name }
    });
  },
  resetPalette: (palette: any) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/palette/palettes/${palette}/`
    });
  }
};

export default {
  ...palette
};
